import React, { useEffect, useState } from "react";
import styles from "./index.module.scss";
import SocialNetworks from "../../../UI/SocialNetworks";
import { useRouter } from "next/router";
import Link from "next/link";
import * as dayjs from "dayjs";
import BlogButton, { NextIcon, PrevIcon } from "../BlogButton";

const localeNames = {
  en: "English",
  ru: "Russian",
};

export default function Header(props) {
  const {
    title,
    avatar,
    author,
    date,
    readingTime,
    description,
    bgColor,
    image = null,
    locales = [],
    prevPost = null,
    nextPost = null,
    titleRef,
  } = props;
  const { query, asPath } = useRouter();
  const [hiddenLocales, setHiddenLocales] = useState(true);
  useEffect(() => {
    const locales = [
      "ru",
      "ru-md",
      "by",
      "ro-md",
      "be",
      "kz",
      "ua",
      "az",
      "md",
      "tj",
      "uz",
      "kg",
    ];
    if (
      locales.indexOf(window.navigator.language.toLocaleLowerCase()) > -1 ||
      window.location.hostname === "localhost"
    ) {
      setHiddenLocales(false);
    }
  }, []);
  return (
    <section className={styles.container}>
      <div className="container">
        <div className={styles.img1} />
        <div className={styles.img2} />
        <div className={styles.img3} />
        <div className={styles.content}>
          <div className={styles.meta}>
            <div className={styles.author}>
              <div className={styles.avatar}>
                <img src={avatar} loading="lazy" alt={author} />
              </div>
              {author}
            </div>
            <div className={styles.date}>
              {dayjs(date).format("MMMM DD, YYYY")}
            </div>
            <div className={styles.readingTime}>{readingTime} min read</div>
            {locales.length > 1 && !hiddenLocales && (
              <div className={styles.bar}>
                <div className={styles.locales}>
                  {locales.map((e, i) => (
                    <Link
                      key={i}
                      href={asPath.replace(
                        /^(\/blog\/)([A-z]{0,2}\/)?/i,
                        `$1${e === "en" ? "" : `${e}/`}`
                      )}
                    >
                      <a
                        className={`${styles.el} ${
                          (query.slug ? query.lang : "en") === e &&
                          styles.active
                        }`}
                      >
                        <span className={styles.desktop}>{localeNames[e]}</span>
                        <span className={styles.mobile}>{e}</span>
                      </a>
                    </Link>
                  ))}
                </div>
              </div>
            )}
          </div>
          <h1 className={styles.title} ref={titleRef}>
            {title}
          </h1>
          <p className={styles.text}>{description}</p>
          <div className={styles.bottom}>
            <div>
              <div className={styles.readingTime}>{readingTime} min read</div>
            </div>
            <div className={styles.actions}>
              {prevPost && (
                <Link href={`/blog/${prevPost.identifier}`}>
                  <a>
                    <BlogButton>
                      <PrevIcon /> Previous post
                    </BlogButton>
                  </a>
                </Link>
              )}
              {nextPost && (
                <Link href={`/blog/${nextPost.identifier}`}>
                  <a>
                    <BlogButton>
                      Next post <NextIcon />
                    </BlogButton>
                  </a>
                </Link>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className={styles.image} style={{ backgroundColor: bgColor }}>
        {image && <img src={image} alt={title} />}
      </div>
    </section>
  );
}
